export const INTERNAL_ERROR_MESSAGE = 'Internal server error!';
export const COMMON_ERROR_MESSAGE = 'Something went wrong';
export const TOO_MANY_REQUESTS_MESSAGE = 'Too many requests. Please try again later.';
export const ERROR_403_CONSTRUCTION_BUDGET = 'Please refresh the page. You cannot update the Construction Budget in the current status of the application.';
